import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getPropertyLabel } from 'customer-data-property-utils/PropertyDisplay';
import PropertyValue from './PropertyValue';
import { isCurrency } from 'customer-data-objects/property/PropertyIdentifier';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CompactProperties = ({
  object,
  objectTypeDefinition,
  item,
  getIsUngated,
  currencyFormatOptions,
  isCompact
}) => {
  const hasTooltip = isCompact || currencyFormatOptions && isCurrency(item.definition);
  if (hasTooltip) {
    const label = getPropertyLabel(item.definition);
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [isCompact && /*#__PURE__*/_jsxs("span", {
          children: [label, ": "]
        }), /*#__PURE__*/_jsx(PropertyValue, {
          object: object,
          objectTypeDefinition: objectTypeDefinition,
          item: item,
          getIsUngated: getIsUngated
        })]
      }),
      children: /*#__PURE__*/_jsx("span", {
        "data-test-id": "cdbc-property-value",
        children: /*#__PURE__*/_jsx(PropertyValue, {
          object: object,
          objectTypeDefinition: objectTypeDefinition,
          item: item,
          currencyFormatOptions: currencyFormatOptions,
          getIsUngated: getIsUngated
        })
      })
    });
  }
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": "cdbc-property-value",
    children: /*#__PURE__*/_jsx(PropertyValue, {
      object: object,
      objectTypeDefinition: objectTypeDefinition,
      item: item,
      currencyFormatOptions: currencyFormatOptions,
      getIsUngated: getIsUngated
    })
  });
};
export default CompactProperties;